import { FunctionComponent, useState } from 'react';
import Rater from 'react-rater';

// Styles
import styles from './Comment.module.scss';

// Components
import Image from '@Components/Utils/Image';
import CommentItem from '@Pages/tra-cuu/bac-si/Components/Comment/CommentItem';

// Utils
import classnames from 'classnames';
import doctorApi, { useRatingDoctor } from '@Libs/api/user/doctor';

// Contexts
import { useHttpContext } from '@Libs/http';
import { useDataTransfer } from '@Components/Utils/DataTransfer';
import { useViewDetected, ViewMedia } from '@Components/Utils/ViewDetected';

// Icons
import Scroller from '@Components/Utils/Scroller';

interface CommentProps {}

const Comment: FunctionComponent<CommentProps> = () => {
    const { doctor } = useDataTransfer();
    const { deviceType } = useViewDetected();
    const { userHttp } = useHttpContext();


    const [hasMore, setHasMore] = useState(true);
    const [payload, setPayload] = useState({
        offset: 0,
        limit: 10,
    });

    const { data: ratingDoctor, mutate } = useRatingDoctor(doctor?.id, { offset: payload.offset, limit: payload.limit }, `${doctor?.id}`);
    const listRatings = ratingDoctor?.ratings || [];

    const handleLoadMoreComment = async () => {
        if (hasMore) {
            const nextPayload = {
                offset: payload.offset + payload.limit,
                limit: payload.limit,
            };
            const responseComment = await doctorApi(userHttp).getRatingDoctor(doctor.id, nextPayload);

            const nextRatings = responseComment?.ratings || [];
            setHasMore(nextRatings?.length >= payload.limit);
            mutate({ ...ratingDoctor, ratings: [...listRatings, ...nextRatings] }, false);

            setPayload(nextPayload);
        }
    };

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
    ]);

    const { profile } = doctor || {};

    return (
        <div className={className}>
            <div className={styles.body}>
                <div className={styles.title_wrapper}>
                    <span className={styles.title}>
                            Đánh giá từ người dùng
                        <ViewMedia is="desktop">
                            <span className={styles.total_rating}>{profile?.rating?.count ? `(${profile?.rating?.count})` : null}</span>
                        </ViewMedia>
                    </span>
                    <div className={styles.star_wrapper}>
                        <Rater total={5} rating={profile?.rating?.average || 0} interactive={false} />
                        <span className={styles.average_rating}>{profile?.rating?.average}</span>
                    </div>
                </div>
                <div className={styles.comments}>
                    {listRatings?.length > 0 ? (
                        <Scroller className={styles.scroller} onBottom={handleLoadMoreComment}>
                            {listRatings.map((rating) => {
                                return <CommentItem key={rating.id} comment={rating} className={styles.comment_item} bodyClassName={styles.item_body} />;
                            })}
                        </Scroller>
                    ) : (
                        <div className={styles.empty_wrapper}>
                            <Image className={styles.img_empty} src="/assets/tra-cuu/bac-si/empty_review.png" />
                            <span className={styles.empty_title}>Chưa có đánh giá!</span>
                            <span className={styles.empty_content}>Trở thành người đánh giá đầu tiên bằng việc tư vấn ngay với Bác sĩ.</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Comment;
